import apiClient from './client';

export const familyCurrenciesApi = {
  list: () => apiClient.get('/guardians/family_currencies'),
  create: (payload) => {
    const body =
      typeof payload === 'string'
        ? { family_currency: { name: payload } }
        : { family_currency: payload };
    return apiClient.post('/guardians/family_currencies', body);
  },
  update: (id, attrs) =>
    apiClient.patch(`/guardians/family_currencies/${id}`, { family_currency: attrs }),
  remove: (id) => apiClient.delete(`/guardians/family_currencies/${id}`),
  mint: (id, amount) =>
    apiClient.post(`/guardians/family_currencies/${id}/mint`, { amount }),
  burn: (id, amount) =>
    apiClient.post(`/guardians/family_currencies/${id}/burn`, { amount }),
  updateSettings: (settings) =>
    apiClient.patch('/guardians/family_currencies/settings', settings),
  peers: (id) => apiClient.get(`/guardians/family_currencies/${id}/peers`),
  recentMemos: (id) =>
    apiClient.get(`/guardians/family_currencies/${id}/recent_memos`),
  transactions: (id, params = {}) =>
    apiClient.get(`/guardians/family_currencies/${id}/transactions`, { params }),
  transfer: (id, payload) =>
    apiClient.post(`/guardians/family_currencies/${id}/transfer`, payload)
};

export default familyCurrenciesApi;
